import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { ConsoleEffects } from "./+state/effects";

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([ConsoleEffects])]
})
export class DevToolsDataAccessModule {}
